/*@ngInject*/
const BinaryConditionController = function ($element, $rootScope, $stateParams, localization, ruleMediator, umStudioConstant, ruleModel, configurationMediator, fieldType) {

    $element.addClass('binaryCondition');

    this.IS_IN_LIST = 'is in list';
    this.IS_IN_CLASS_CODE_LIST = 'is in class code list';

    this.operators = [];
    this.operatorDropdownPrompt = '';

    localization.getTranslationByKey('binaryCondition').then((translations) => {
        let typeName,
            isField;

        this.operatorDropdownPrompt = _.get(translations, 'operatorDropdownPrompt');

        this.getOperatorName = function () {
            let operatorName = this.operatorDropdownPrompt;
            if (!_.isNil(this.ruleCondition.operatorName)) {
                operatorName = this.getOperator18n(this.ruleCondition.operatorName);
            }

            return operatorName;
        };

        this.changeOperator = function (operator) {
            if (this.ruleCondition.operatorName !== operator) {
                if (this.ruleCondition.operatorName === 'exists') {
                    configurationMediator.getFieldOptions(this.ruleCondition.lhs.formTemplateUniqueName, this.ruleCondition.lhs.fieldName).then((result) => {
                        let fieldOption = {};
                        if (!_.isEmpty(result)) {
                            fieldOption = result[0];
                        }

                        this.ruleCondition.lhs.typeName = fieldOption.typeName;
                    });
                }

                this.ruleCondition.operatorName = operator;
                this.isInListOptionSelected = operator === this.IS_IN_LIST;
                this.isInClassCodeListOptionSelected = operator === this.IS_IN_CLASS_CODE_LIST;

                if (operator === 'exists') {
                    this.ruleCondition.rhs = null;
                } else if (this.isInListOptionSelected || this.isInClassCodeListOptionSelected) {
                    this.ruleCondition.rhs = {
                        objectUri: '/LiteralValue'
                    };
                } else {
                    this.ruleCondition.rhs = {
                        objectUri: '/LiteralValue'
                    };
                }

                $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
            }
        };

        this.getOperator18n = function (operator) {
            let translation = _.get(translations, `operators.${operator}`);
            if (_.isNil(translation)) {
                translation = operator;
            }
            return translation;
        };

        this.notifyLhsValueChange = function (ruleConditionValue, type, isField) {
            this.ruleCondition.lhs = ruleConditionValue;
            if (type) {
                this.refreshOperators(type, isField);
            } else {
                this.ruleCondition.operatorName = null;
                this.ruleCondition.rhs = {
                    objectUri: '/LiteralValue'
                };
            }

            $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
        };

        this.notifyRhsValueChange = function (ruleConditionValue) {
            this.ruleCondition.rhs = ruleConditionValue;

            $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
        };

        this.refreshOperators = function (type, isField) {
            if (this.ruleCondition.operatorName === 'exists') {
                configurationMediator.getFieldOptions(this.ruleCondition.lhs.formTemplateUniqueName, this.ruleCondition.lhs.fieldName).then((result) => {
                    let fieldOption = {};
                    if (!_.isEmpty(result)) {
                        fieldOption = result[0];
                    }
                    ruleMediator.getOperators(fieldOption.typeName ? fieldOption.typeName : type, isField).then((operators) => {
                        this.operators = operators;
                    });
                });
            } else {
                ruleMediator.getOperators(type, isField).then((operators) => {
                    this.operators = operators;

                    if (!_.isEmpty(this.ruleCondition.lhs.formTemplateUniqueName) && !_.isEmpty(this.ruleCondition.lhs.fieldName)) {
                        configurationMediator.findUIFieldByUIFormTemplateUniqueNameAndFieldName(this.ruleCondition.lhs.formTemplateUniqueName, this.ruleCondition.lhs.fieldName).then((uiField) => {
                            if (uiField.fieldTemplate.type === fieldType.CLASSCODEFINDER) {
                                // Filter out the "is in list" operator
                                this.operators = _.filter(this.operators, (operator) => {
                                    return operator !== this.IS_IN_LIST;
                                });
                            } else {
                                // Filter out the "is in class code list" operator
                                this.operators =_.filter(this.operators, (operator) => {
                                    return operator !== this.IS_IN_CLASS_CODE_LIST;
                                });
                            }
                        });
                    } else {
                        // Filter out the "is in class code list" operator
                        this.operators = _.filter(this.operators, (operator) => {
                            return operator !== this.IS_IN_CLASS_CODE_LIST;
                        });
                    }
                });
            }
        };

        this.shouldShowLeftSideFieldValueOption = function () {
            return (this.ruleCondition.lhs.formTemplateUniqueName && this.ruleCondition.lhs.fieldName && (this.ruleCondition.operatorName === '==' || this.ruleCondition.operatorName === this.IS_IN_LIST));
        };

        this.shouldShowLeftSideFieldValueClassCodeOption = function () {
            return (this.ruleCondition.lhs.formTemplateUniqueName && this.ruleCondition.lhs.fieldName && (this.ruleCondition.operatorName === '==' || this.ruleCondition.operatorName === this.IS_IN_CLASS_CODE_LIST));
        };

        if (this.ruleCondition.lhs && this.ruleCondition.lhs.typeName) {
            typeName = this.ruleCondition.lhs.typeName;
            isField = this.ruleCondition.lhs.fieldName ? true : false;
            this.refreshOperators(typeName, isField);
            this.isInListOptionSelected = this.ruleCondition.operatorName === this.IS_IN_LIST;
            this.isInClassCodeListOptionSelected = this.ruleCondition.operatorName === this.IS_IN_CLASS_CODE_LIST;
        }
    });
};

angular.module('umCore')
    .controller('binaryConditionController', BinaryConditionController);
